import { Appointment } from '@myapp/contract'
import { getTopPx, getHeightPx } from '../model/calendarConstants'
import { getAppointmentColors, COMPLETED_TRAVEL_COLOR } from '../../../shared/lib/timelineColors'
import { shortLocation } from '../../../shared/helpers/address'

interface Props {
  appointment: Appointment
  onClick: () => void
  isTransferTravel?: boolean
  isTransferDeparture?: boolean
  left?: string
  zIndex?: number
}

export const WorkerAppointmentBlock = ({ appointment, onClick, isTransferTravel, isTransferDeparture, left, zIndex }: Props) => {
  const { workColor, travelColor } = getAppointmentColors(appointment.status)

  const isCompleted = appointment.status === 'COMPLETED' || appointment.status === 'COMPLETED_WITH_FOLLOW_UP'
  const isInProgress = !!appointment.actualStart && !appointment.actualEnd
  const useActuals = isCompleted || isInProgress

  const travelDuration = useActuals ? (appointment.actualTravelDuration ?? appointment.plannedTravelDuration) : appointment.plannedTravelDuration
  const workDuration = useActuals ? (appointment.actualWorkDuration ?? appointment.plannedWorkDuration) : appointment.plannedWorkDuration
  const departureDuration = useActuals ? (appointment.actualDepartureDuration ?? appointment.plannedDepartureDuration) : appointment.plannedDepartureDuration

  // actualStart = початок роботи (Work), після Anfahrt
  // anfahrtStart = actualStart - actualTravel
  const workStart = useActuals && appointment.actualStart
    ? new Date(appointment.actualStart)
    : new Date(appointment.plannedStart)

  const anfahrtStart = new Date(workStart.getTime() - travelDuration * 60_000)

  const effectiveTravelColor = isInProgress ? COMPLETED_TRAVEL_COLOR : travelColor

  const totalMinutes = travelDuration + workDuration + departureDuration

  const top = getTopPx(anfahrtStart.toISOString())
  const height = Math.max(getHeightPx(totalMinutes), 20)

  const travelPx = getHeightPx(travelDuration)
  const workPx = getHeightPx(workDuration)
  const departurePx = getHeightPx(departureDuration)

  const hasAttachments = !!appointment.attachments?.length

  const ext = appointment.workOrder?.external ?? null
  const address = shortLocation(ext)
  const wohnung = ext?.wohnung ?? null
  const gewerkeText = ext?.gewerkeText ?? null
  const leistungText = ext?.leistungText ?? null
  const individuellerText = ext?.individuellerText ?? null
  const mieterName = ext?.mieter?.name ?? null
  const mieterTelefon = ext?.mieter?.telefon ?? null

  const timeLabel = `${String(workStart.getHours()).padStart(2, '0')}:${String(workStart.getMinutes()).padStart(2, '0')}`

  return (
    <div
      data-block
      className="absolute right-0.5 flex flex-col rounded overflow-hidden cursor-pointer gap-px"
      style={{ top, height, left: left ?? '2px', zIndex: zIndex ?? 10 }}
      onClick={(e) => { e.stopPropagation(); onClick() }}
    >
      {travelDuration > 0 && (
        <div
          className="flex items-center px-1 text-white text-[12px] font-semibold overflow-hidden shrink-0 rounded-sm"
          style={{ backgroundColor: effectiveTravelColor, height: travelPx, minHeight: 12 }}
        >
          {isTransferTravel ? 'Transfer' : 'Anfahrt'}
        </div>
      )}
      <div
        className="relative flex flex-col justify-start px-1 text-white text-[12px] font-semibold overflow-hidden rounded-sm py-1"
        style={{ backgroundColor: workColor, height: workPx, minHeight: 16, flexShrink: 0 }}
      >
        {isInProgress && (
          <>
            <div
              className="absolute inset-0 rounded-sm ring-2 ring-inset ring-white animate-pulse pointer-events-none"
              aria-hidden
            />
            <span className="self-start inline-flex items-center gap-1 px-1 py-px rounded bg-red-500 text-white text-[9px] font-bold uppercase leading-none max-w-full mb-0.5">
              <span className="w-1 h-1 rounded-full bg-white animate-pulse shrink-0" />
              <span className="truncate">Läuft</span>
            </span>
          </>
        )}
        <span className="font-semibold leading-tight">{timeLabel}</span>
        {address && <span className="leading-3 line-clamp-2 break-words">{address}</span>}
{/*         {wohnung && <span className="leading-tight line-clamp-1 opacity-90 text-[11px]">Whg. {wohnung}</span>}
 */}{/*         {gewerkeText && <span className="leading-tight line-clamp-1 opacity-90 text-[11px]">{gewerkeText}</span>}
 */}        {/* {leistungText && <span className="leading-tight line-clamp-1 opacity-75 text-[10px] font-normal">{leistungText}</span>} */}
     {/*    {individuellerText && <span className="leading-tight line-clamp-2 opacity-75 text-[10px] font-normal italic mt-0.5">{individuellerText}</span>} */}
        {(mieterName || mieterTelefon) && (
          <span className="leading-tight line-clamp-1 break-words mt-auto text-[11px]">
            {mieterName}{mieterTelefon ? ` · ${mieterTelefon}` : ''}
          </span>
        )}
        {hasAttachments && (
          <span className="absolute top-1 right-1 text-[13px] leading-none z-10 pointer-events-none">📁</span>
        )}
      </div>
      {departureDuration > 0 && (
        <div
          className="flex items-center px-1 text-white text-[12px] font-semibold overflow-hidden shrink-0 rounded-sm"
          style={{ backgroundColor: travelColor, height: departurePx, minHeight: 12 }}
        >
          {isTransferDeparture ? 'Transfer' : 'Abfahrt'}
        </div>
      )}
    </div>
  )
}
